// removed by extract-text-webpack-plugin
module.exports = {"checkbox-wrapper":"checkbox-wrapper__132fc"};


//////////////////
// WEBPACK FOOTER
// ./components/form/styles/CheckboxInput.scss
// module id = KsQz
// module chunks = 1